const items = [
  "Uma situação. Uma missão.",
  "Tempo Livre",
  "Agenda Viva",
  "Caixa Hoje",
  "Cliente Traz Cliente",
  "Influência x Receita",
  "Basic Recepção",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-white/10 bg-black py-6">
      <div className="hc-marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex w-max items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap px-10 font-display text-xl font-light italic text-white/45 sm:text-2xl">
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rounded-full bg-hc-lilac/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
